import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
import LOCATIONS from '../enums/Location';
import T from "i18n-react";

class ShopService {

    /**
     * Récupère la liste 
     */
    getShopList(idBu) {
        const url = '/api/shop' + (idBu ? `?idBu=${idBu}`: '');
        return WebService.call(url, HttpMethods.GET)
    }

    /**
     * Récupère la liste paginée pour la page historique des magasins
     */
    getShopInformationList(page, size = 0, location, client, bu, search) {
        let url = `/api/shop/informationList?page=${page-1}&size=${size}`;
        url += location ? `&location=${location}` : '';
        url += client ? `&client=${client}` : '';
        url += bu ? `&bu=${bu}` : '';
        url += search ? `&search=${search}` : '';
        return WebService.call(url, HttpMethods.GET, null);
    }

    /**
     * Récupère toutes les associations d'un magasin à un code pass
     * @param {*} idShop
     */
    getShopAssociations(idShop) {
        return WebService.call('/api/shop/' + idShop + '/associations', HttpMethods.GET)
    }

    /**
     * Récupère les BU associées à un magasin auquel l'utilisateur a accès
     * @param {*} idShop
     */
    getAssociatedBuList(idShop) {
        return WebService.call('/api/shop/' + idShop + '/bulist', HttpMethods.GET)
    }

    //Renvoie la valeur du code spécifique au pays du magasin
    getShopLocationSpecificCodeValue(shop) {
        if(shop && shop.location) {
            switch (shop.location) {
                case LOCATIONS.FR:
                    return shop.pass || T.translate('shopPage.inactiveShop');
                case LOCATIONS.BE:
                    return shop.gln;
                case LOCATIONS.ES:
                    return shop.atica;
                default:
                    return null;
            }
        }
        return null;
    }

    //Renvoie le label correspondant au code spécifique au pays du magasin
    getShopLocationSpecificCodeLabel(location) {
        switch(location){
            case LOCATIONS.BE:
                return 'codeGln';
            case LOCATIONS.FR:
                return 'codePass';
            case LOCATIONS.ES:
                return 'codeAtica';
            default:
                return null;
        }
    }

}

export default new ShopService();



// WEBPACK FOOTER //
// ./src/services/ShopService.js